import { render, staticRenderFns } from "./CustomerQuickBase.vue?vue&type=template&id=58e19e24&scoped=true&"
import script from "./CustomerQuickBase.vue?vue&type=script&lang=js&"
export * from "./CustomerQuickBase.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQuickBase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerQuickBase.vue?vue&type=style&index=1&id=58e19e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e19e24",
  null
  
)

export default component.exports